// import BookingRequestSkeleton from "../../Components/Loader/Skeleton/BookingRequestSkeleton";
import { useEffect, useState } from "react";
import {
  _24To12,
  _HHMMSS_To_HHMM,
  decryptor,
  getPayloadHash,
} from "../../services/helper";
import { postFormDataCall } from "../../services/apiCall";
import { getLocalToken } from "../../services/token";
import { Link } from "react-router-dom";

const YourBooking = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [booking, setBooking] = useState([]);

  const getBookings = async () => {
    setIsLoading(true);

    const token = getLocalToken();
    let userInfo = decryptor({ encryptedData: token });
    if (!userInfo) return null;

    userInfo = JSON.parse(userInfo);

    const payload = {
      user_id: userInfo?.user_id,
    };
    const dataToSend = getPayloadHash({ data: payload });
    let response = await postFormDataCall(
      "/get-accepted-bookings",
      {},
      { data: dataToSend }
    );

    if (response?.success && response?.data) {
      setBooking(response.data?.bookings);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getBookings();
  }, []);

  return (
    <>
      <h1 className="text-3xl font-semibold sticky top-0 bg-white z-40 py-3 border-b border-gray-300">
        Your Bookings
      </h1>
      {isLoading ? (
        <>Loading...</>
      ) : (
        <div className="w-full mx-auto p-2 bg-gray-100 min-h-[calc(100vh-175px)]">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {booking?.map((item) => (
              <div className="bg-white p-5 rounded-md shadow-md border border-gray-300 flex flex-col gap-3 text-gray-700">
                <img
                  src={item.service_details.image}
                  alt={item.service_details.name}
                  className="w-full h-48 object-cover rounded-md"
                />

                <h2 className="text-xl font-bold text-gray-900">
                  {item.service_details.name}
                </h2>

                <div className="mt-2">
                  <p>
                    <span className="text-gray-800 font-bold">
                      Amount Paid:{" "}
                    </span>
                    <span className="text-green-500 font-bold">
                      ₹{item.booking_details.amount}
                    </span>
                  </p>
                  <p>
                    <span className="text-gray-800 font-bold">
                      Start Time:{" "}
                    </span>
                    {item.booking_details.start_time}
                  </p>
                  <p>
                    <span className="text-gray-800 font-bold">End Time: </span>
                    {item.booking_details.end_time}
                  </p>
                  <p>
                    <span className="text-gray-800 font-bold">Status: </span>
                    <span
                      className={`font-bold capitalize ${
                        item.booking_details.status === "accepted"
                          ? "text-green-500"
                          : "text-red-500"
                      }`}
                    >
                      {item.booking_details.status}
                    </span>
                  </p>
                </div>

                {/* User Details */}
                <div className="mt-2 border-t pt-2">
                  <h3 className="text-lg font-semibold text-gray-800">
                    User Details
                  </h3>
                  <p className="text-sm">
                    <span className="font-bold">Name:</span>{" "}
                    {item.user_details.name}
                  </p>
                  {/* <p className="text-sm">
                    <span className="font-bold">Email:</span>{" "}
                    {item.user_details.email}
                  </p>
                  <p className="text-sm">
                    <span className="font-bold">Phone:</span>{" "}
                    {item.user_details.phone}
                  </p>
                  <p className="text-sm">
                    <span className="font-bold">Address:</span>{" "}
                    {item.user_details.address}
                  </p> */}
                </div>

                {/* Accept Button */}
                <div className="flex mt-2">
                  <Link
                    to={`/company/booking/${item.booking_id}`}
                    className="w-full px-4 py-2 border-2 font-bold border-blue-500 text-blue-500 rounded-md bg-blue-50 hover:scale-105 transition-all duration-100 ease-in-out flex justify-center"
                  >
                    View
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default YourBooking;
